<script>
	import { onMount } from "svelte";
    import { onDestroy } from 'svelte';
	import { showheader } from '../store.js';
	import { link } from 'svelte-spa-router';
	onMount(() => {
		document.title = '模拟选号器';
		showheader.set(false);
	});
	onDestroy(() => {
		document.title = '';
		showheader.set(true);
	});
	function articleLink(){
		if(window.__wxjs_environment === 'miniprogram'){
			wx.miniProgram.navigateTo({
				url: '/pages/qrpage/qrpage'
			})
		}else{
			location.href = 'https://mp.weixin.qq.com/s?__biz=MzkzNjQwMjY2OA==&mid=2247484016&idx=1&sn=e66ac24d728d16b8e73d21fa44d72fcc&chksm=c29e09f3f5e980e5244e38920a8199740bb426170ab200d6d14198c49b01a239c34de43d8d02#rd';
		}
	};
</script>
<div style="height: 2rem;"></div>
<main>
	<a class="card" use:link={'/sdf'}>
		<img src="https://cdn.wangzhanb.com/xiaochengxu/b1/assets/block-ssq-m.png" alt/>
		<span>双色球单式复式选号</span>
	</a>
	<a class="card" use:link={'/ddf'}>
		<img src="https://cdn.wangzhanb.com/xiaochengxu/b1/assets/logo_dlt.png" alt/>
		<span>大乐透单式复式选号</span>
	</a>
	<a class="card" style="background-color: gold;" use:link={'/qdf'}>
		<img src="https://cdn.wangzhanb.com/xiaochengxu/b1/assets/logo-7xc.png" alt/>
		<span style="color: #000;">七星彩单式复式选号</span>
	</a>
	<a class="card" style="background-color: #E94560;" use:link={'/sdt'}>
		<img src="https://cdn.wangzhanb.com/xiaochengxu/b1/assets/block-ssq-m.png" alt/>
		<span>双色球胆拖式选号</span>
	</a>
	<a class="card" style="background-color: #E94560;" use:link={'/ddt'}>
		<img src="https://cdn.wangzhanb.com/xiaochengxu/b1/assets/logo_dlt.png" alt/>
		<span>大乐透胆拖式选号</span>
	</a>
	<a class="card" style="background-color: #00AC84;" on:click={articleLink}>
		<img src="https://cdn.wangzhanb.com/xiaochengxu/b1/assets/aaccc.png" alt/>
		<span>微信扫码选号</span>
	</a>
</main>
<style>
	main {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		position: relative;
		z-index: 3;
	}
	.card {
		display: block;
		width: 86%;
		margin-bottom: .8rem;
		background-color: #2f2386;
		border-radius: 1rem;
		height: 3.2rem;
		box-sizing: border-box;
		padding-left: 0.8rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.card img {
		height: 2.2rem;
		width: 2.2rem;
	}
	.card span {
		display: inline-block;
		padding-left: 1rem;
		color: var(--base-link-c);
		text-decoration: none;
		font-size: 1.12rem;
		font-weight: bold;
	}
</style>
